import "./requestDetail.css";
import { IoIosArrowBack, IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { FaEye, FaAsterisk } from "react-icons/fa";
import { MdCancel } from "react-icons/md";
import { GoDotFill } from "react-icons/go";
import useRequestDetailLogic from "./RequestDetailLogic";
import { BiSolidPhoneCall } from "react-icons/bi";
import { useState, useRef, useEffect } from "react";
import DialModal from "./DialModal";
import { FiPhone, FiPhoneOutgoing, FiVolume2 } from "react-icons/fi";
import { FiUser, FiHeadphones } from "react-icons/fi";
import ReactDOM from "react-dom";
import { FiChevronDown, FiX, FiFileText, FiAlertCircle, FiMessageSquare } from "react-icons/fi";
import { FiPlay, FiPause, FiMicOff, FiArrowRight, FiPhoneIncoming, FiClock } from "react-icons/fi";
import { MdOutlineAnalytics } from "react-icons/md";
import { RiCustomerService2Fill } from "react-icons/ri";
import { useCustomContext } from "../CustomComponents/CustomComponents";
import CallRecordingPlayerModal from "./RecordPlayerModal";
import { BsRobot, BsPerson, BsPinAngle, BsPinAngleFill } from "react-icons/bs";

const RequestDetail = () => {

    const {
        navigate,
        record,
        setRecord,
        isLoadingRecord,
        openSection,
        toggleSection,
        showAddModal,
        setShowAddModal,
        textArea,
        setTextArea,
        handleTextSubmit,
        showEventModal,
        setShowEventModal,
        eventData,
        setEventData,
        showChequeModal,
        setShowChequeModal,
        showViewChequeModal,
        setShowViewChequeModal,
        chequePdfUrl,
        setChequePdfUrl,
        chequePaymentTo,
        setChequePaymentTo,
        chequeAmount,
        chequeAddress,
        setChequeAddress,
        chequeMemo,
        setChequeMemo,
        chequeData,
        viewChequeRequestId,
        handleOpenChequeModal,
        handleGenerateCheque,
        handleViewCheque,
        handleAmountChange,
        handleCopy,
        reqMethodKey,
        resMethodKey,
        freqType,
        viewHighlightFileds,
        formatToLocalDateTime,
        handleViewPDF,
        handleViewFilePDF,
        handleEventSubmit,
        eventErrors,
        setEventErrors,
        shouldShowCallAction,
        callHistory,
        setCallHistory,
        fetchCallHistory,
        getAudioUrl,
        isPinned,
        setIsPinned,
        handlePinNote,
        chequeErrors,
        setChequeErrors,
        noteError,
        setNoteError,
        handlePayableToChange,
        getNowDateTimeLocal,
    } = useRequestDetailLogic();

    const [modalOpen, setModalOpen] = useState(false);
    const [modalItem, setModalItem] = useState(null);

    const [dialOpen, setDialOpen] = useState(false);
    const [dialRequestId, setDialRequestId] = useState("");

    const [audioUrl, setAudioUrl] = useState(null);
    const [playingId, setPlayingId] = useState(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const [duration, setDuration] = useState(0);
    const [currentTime, setCurrentTime] = useState(0);
    const audioRef = useRef(null);
    const [expandedAnalysis, setExpandedAnalysis] = useState(null);
    const { showAlert } = useCustomContext();

    // useEffect(() => {
    //     if (agencyPhoneNumber) {
    //         localStorage.setItem("CurrentAgencyNumber", agencyPhoneNumber);
    //     }
    // }, [agencyPhoneNumber]);

    const refreshPage = () => {
        window.location.reload();
    }

    const handlePlay = async (key, id) => {
        try {

            // SAME AUDIO CLICKED
            if (playingId === id && audioRef.current) {

                if (isPlaying) {

                    audioRef.current.pause();
                    setIsPlaying(false);

                } else {

                    await audioRef.current.play();
                    setIsPlaying(true);
                }

                return;
            }

            // STOP OLD AUDIO
            if (audioRef.current) {
                audioRef.current.pause();
                audioRef.current.currentTime = 0;
            }

            // GET NEW URL
            const url = await getAudioUrl(key);

            // SET STATES
            setAudioUrl(url);
            setPlayingId(id);
            setCurrentTime(0);

            // SET AUDIO SOURCE MANUALLY
            if (audioRef.current) {

                audioRef.current.src = url;

                await audioRef.current.play();

                setIsPlaying(true);
            }

        } catch (err) {

            console.error("Error playing audio:", err);
        }
    };



    const handleOpenCallforAction = () => {
        const phone = record?.agencyPhoneNumber;
        console.log("Final Phone Used:", phone);
        if (phone) {
            setDialRequestId(record.requestID);
            setDialOpen(true);
        }
        else {
            showAlert(
                "Agency phone number is not available for calling.",
                [
                    {
                        label: "Ok",
                        onClick: () => { },
                        color: "var(--buttonColor)"
                    }
                ]
            );
        }
    }

    const closeAnalysisModal = () => {

        // stop audio
        if (audioRef.current) {
            audioRef.current.pause();
            audioRef.current.currentTime = 0;
            audioRef.current.src = "";
        }

        // reset states
        setIsPlaying(false);
        setPlayingId(null);
        setAudioUrl("");

        // close modal
        setExpandedAnalysis(null);
    };

    const handleHistoryToggle = async () => {
        if (openSection.includes("history")) {
            if (audioRef.current) {
                audioRef.current.pause();
                audioRef.current.currentTime = 0;
            }

            setAudioUrl(null);
            setPlayingId(null);
            setIsPlaying(false);
            setCurrentTime(0);
            setDuration(0);

            setCallHistory([]);

            toggleSection("history");
            setExpandedAnalysis(null);

        } else {
            toggleSection("history");
            setExpandedAnalysis(null);

            await fetchCallHistory(record.requestID);
        }
    };

    const formatTime = (time) => {
        if (!time) return "00:00";

        const total = Math.floor(time); // 🔥 important
        const minutes = Math.floor(total / 60);
        const seconds = (total % 60).toString().padStart(2, "0");

        return `${minutes}:${seconds}`;
    };
    useEffect(() => {
        const audio = audioRef.current;
        if (!audio) return;

        const onLoaded = () => setDuration(audio.duration);
        const onTimeUpdate = () => setCurrentTime(audio.currentTime);
        const onEnded = () => setIsPlaying(false);

        audio.addEventListener("loadedmetadata", onLoaded);
        audio.addEventListener("timeupdate", onTimeUpdate);
        audio.addEventListener("ended", onEnded);

        return () => {
            audio.removeEventListener("loadedmetadata", onLoaded);
            audio.removeEventListener("timeupdate", onTimeUpdate);
            audio.removeEventListener("ended", onEnded);
        };
    }, [audioUrl]);

    if (isLoadingRecord) {
        return (
            <div className="main-content">
                <div className="p-2 custom-bg-white rounded d-flex align-items-center gap-3">
                    <button
                        className="back-btn_RD"
                        onClick={() =>
                            navigate("/RequestSentDetails", {
                                state: { fromRequestDetail: true }
                            })
                        }>
                        <IoIosArrowBack /> Back
                    </button>
                </div>
                <div className="custom-bg-white main-content-2_RD No_records_Found mt-4 p-3">
                    Loading record...
                </div>
            </div>
        );
    }

    if (!record?.requestID) {
        return (
            <div className="main-content">
                <div className="p-2 custom-bg-white rounded d-flex align-items-center gap-3">
                    <button
                        className="back-btn_RD"
                        onClick={() =>
                            navigate("/RequestSentDetails", {
                                state: { fromRequestDetail: true }
                            })
                        }>
                        <IoIosArrowBack /> Back
                    </button>
                </div>
                <div className="custom-bg-white main-content-2_RD No_records_Found mt-4 p-3">
                    No record found
                </div>
            </div>
        );
    }

    const notes = record.notes || [];

    const renderRequestMethodDetails = () => {
        const rm = record.requestMethod || {};
        switch (reqMethodKey) {
            case "fax":
                return (
                    <>
                        <label style={{ marginTop: 8, display: "block" }}>Fax Numbers</label>
                        {(rm.faxSettings || []).map((fax, i) => (
                            <input key={i} readOnly value={fax} style={{ marginTop: 5 }} />
                        ))}
                    </>
                );
            case "emailReq":
                return (
                    <>
                        <label style={{ marginTop: 8, display: "block" }}>Email Addresses</label>
                        {(rm.emailSettings || []).map((mail, i) => (
                            <input key={i} readOnly value={mail} style={{ marginTop: 5 }} />
                        ))}
                    </>
                );
            case "snail": {
                const snail = rm.snailMailSettings || {};
                return (
                    <>
                        <label style={{ marginTop: 8, display: "block" }}>Snail Mail Emails</label>
                        {(snail.emailaddress || []).map((mail, i) => (
                            <input key={i} readOnly value={mail} style={{ marginTop: 5 }} />
                        ))}
                        <label style={{ marginTop: 8, display: "block" }}>Name</label>
                        <input readOnly value={snail.address?.name || ""} />
                        <label style={{ marginTop: 8, display: "block" }}>Address</label>
                        <input readOnly value={snail.address?.address || ""} />
                        <div style={{ display: "flex", gap: 8, marginTop: 8 }}>
                            <div style={{ flex: 1 }}><label>City</label><input readOnly value={snail.address?.city || ""} /></div>
                            <div style={{ flex: 1 }}><label>State</label><input readOnly value={snail.address?.state || ""} /></div>
                            <div style={{ flex: 1 }}><label>Zip</label><input readOnly value={snail.address?.zip || ""} /></div>
                        </div>
                    </>
                );
            }
            case "dropoff": {
                const drop = rm.dropoffSettings || {};
                return (
                    <>
                        <label style={{ marginTop: 8, display: "block" }}>Drop Off Emails</label>
                        {(drop.emailaddress || []).map((mail, i) => (
                            <input key={i} readOnly value={mail} style={{ marginTop: 5 }} />
                        ))}
                        <label style={{ marginTop: 8, display: "block" }}>Name</label>
                        <input readOnly value={drop.address?.name || ""} />
                        <label style={{ marginTop: 8, display: "block" }}>Address</label>
                        <input readOnly value={drop.address?.address || ""} />
                        <div style={{ display: "flex", gap: 8, marginTop: 8 }}>
                            <div style={{ flex: 1 }}><label>City</label><input readOnly value={drop.address?.city || ""} /></div>
                            <div style={{ flex: 1 }}><label>State</label><input readOnly value={drop.address?.state || ""} /></div>
                            <div style={{ flex: 1 }}><label>Zip</label><input readOnly value={drop.address?.zip || ""} /></div>
                        </div>
                    </>
                );
            }
            case "agenweb": {
                const agen = rm.agencyWebsiteSettings || {};
                return (
                    <>
                        <label style={{ marginTop: 8, display: "block" }}>Email</label>
                        <input readOnly value={agen.email || ""} />
                        <label style={{ marginTop: 8, display: "block" }}>Website URL</label>
                        <input readOnly value={agen.websiteURL || ""} />
                        <label style={{ marginTop: 8, display: "block" }}>Description</label>
                        <input readOnly value={agen.description || ""} />
                    </>
                );
            }
            case "crashdocx": {
                const crash = rm.crashDocsWebsiteSettings || {};
                return (
                    <>
                        <label style={{ marginTop: 8, display: "block" }}>Email</label>
                        <input readOnly value={crash.email || ""} />
                        <label style={{ marginTop: 8, display: "block" }}>Website URL</label>
                        <input readOnly value={crash.websiteURL || ""} />
                        <label style={{ marginTop: 8, display: "block" }}>Description</label>
                        <input readOnly value={crash.description || ""} />
                    </>
                );
            }
            default: return null;
        }
    };

    const renderResponseMethodDetails = () => {
        const res = record.responseMethod || {};
        switch (resMethodKey) {
            case "fax":
                return (
                    <>
                        <label style={{ marginTop: 8, display: "block" }}>Fax Numbers</label>
                        {(res.faxSettings || []).map((fax, i) => (
                            <input key={i} readOnly value={fax} style={{ marginTop: 5 }} />
                        ))}
                    </>
                );
            case "email":
                return (
                    <>
                        <label style={{ marginTop: 8, display: "block" }}>Email Addresses</label>
                        {(res.emailSettings || []).map((mail, i) => (
                            <input key={i} readOnly value={mail} style={{ marginTop: 5 }} />
                        ))}
                    </>
                );
            case "snailmail": {
                const snail = res.snailMailSettings || {};
                return (
                    <>
                        <label style={{ marginTop: 8, display: "block" }}>Snail Mail Emails</label>
                        {(snail.emailaddress || []).map((mail, i) => (
                            <input key={i} readOnly value={mail} style={{ marginTop: 5 }} />
                        ))}
                        <label style={{ marginTop: 8, display: "block" }}>Name</label>
                        <input readOnly value={snail.address?.name || ""} />
                        <label style={{ marginTop: 8, display: "block" }}>Address</label>
                        <input readOnly value={snail.address?.address || ""} />
                        <div style={{ display: "flex", gap: 8, marginTop: 8 }}>
                            <div style={{ flex: 1 }}><label>City</label><input readOnly value={snail.address?.city || ""} /></div>
                            <div style={{ flex: 1 }}><label>State</label><input readOnly value={snail.address?.state || ""} /></div>
                            <div style={{ flex: 1 }}><label>Zip</label><input readOnly value={snail.address?.zip || ""} /></div>
                        </div>
                    </>
                );
            }
            case "pickup": {
                const pickup = res.pickupSettings || {};
                return (
                    <>
                        <label style={{ marginTop: 8, display: "block" }}>Pick Up Emails</label>
                        {(pickup.emailaddress || []).map((mail, i) => (
                            <input key={i} readOnly value={mail} style={{ marginTop: 5 }} />
                        ))}
                        <label style={{ marginTop: 8, display: "block" }}>Name</label>
                        <input readOnly value={pickup.address?.name || ""} />
                        <label style={{ marginTop: 8, display: "block" }}>Address</label>
                        <input readOnly value={pickup.address?.address || ""} />
                        <div style={{ display: "flex", gap: 8, marginTop: 8 }}>
                            <div style={{ flex: 1 }}><label>City</label><input readOnly value={pickup.address?.city || ""} /></div>
                            <div style={{ flex: 1 }}><label>State</label><input readOnly value={pickup.address?.state || ""} /></div>
                            <div style={{ flex: 1 }}><label>Zip</label><input readOnly value={pickup.address?.zip || ""} /></div>
                        </div>
                    </>
                );
            }
            case "agenweb": {
                const agen = res.agencyWebsiteSettings || {};
                return (
                    <>
                        <label style={{ marginTop: 8, display: "block" }}>Email</label>
                        <input readOnly value={agen.email || ""} />
                        <label style={{ marginTop: 8, display: "block" }}>Website URL</label>
                        <input readOnly value={agen.websiteURL || ""} />
                        <label style={{ marginTop: 8, display: "block" }}>Description</label>
                        <input readOnly value={agen.description || ""} />
                    </>
                );
            }
            case "crashdocs": {
                const crash = res.crashDocsWebsiteSettings || {};
                return (
                    <>
                        <label style={{ marginTop: 8, display: "block" }}>Email</label>
                        <input readOnly value={crash.email || ""} />
                        <label style={{ marginTop: 8, display: "block" }}>Website URL</label>
                        <input readOnly value={crash.websiteURL || ""} />
                        <label style={{ marginTop: 8, display: "block" }}>Description</label>
                        <input readOnly value={crash.description || ""} />
                    </>
                );
            }
            default: return null;
        }
    };
    // console.log(record);
    const renderFrequencyDetails = () => {
        if (!freqType) return null;

        const settings = record.frequency?.frequencySettings || {};

        switch (freqType) {
            case "Weekly":
            case "OddWeekly":
            case "EvenWeekly":
                return (
                    <>
                        <label style={{ marginTop: 8, display: "block" }}>
                            {freqType === "OddWeekly"
                                ? "Odd Week Days"
                                : freqType === "EvenWeekly"
                                    ? "Even Week Days"
                                    : "Week Days"}
                        </label>
                        <input readOnly value={(settings.weekDays || []).join(", ")} />
                    </>
                );

            case "Monthly":
                return (
                    <>
                        <label style={{ marginTop: 8, display: "block" }}>Month Days</label>
                        <input
                            readOnly
                            value={(settings.monthDays || [])
                                .slice()
                                .sort((a, b) => a - b)
                                .join(", ")}
                        />
                    </>
                );

            default:
                return null;
        }
    };
    const getRequestEmailAddress = () => {
        const rm = record.requestMethod || {};

        switch (reqMethodKey) {
            case "emailReq":
                return (rm.emailSettings || []).join(", ");

            case "snail":
                return (rm.snailMailSettings?.emailaddress || []).join(", ");

            case "dropoff":
                return (rm.dropoffSettings?.emailaddress || []).join(", ");

            case "agenweb":
                return rm.agencyWebsiteSettings?.email || "";

            case "crashdocx":
                return rm.crashDocsWebsiteSettings?.email || "";

            case "fax":
                return (rm.faxSettings || []).join(", ");

            default:
                return "";
        }
    };
    return (
        <div className="main-content">

            {/* ── Header ── */}
            <div className="p-2 custom-bg-white rounded d-flex align-items-center gap-3">
                <button
                    className="back-btn_RD"
                    onClick={() =>
                        navigate("/RequestSentDetails", { state: { fromRequestDetail: true } })
                    }
                >
                    <IoIosArrowBack /> Back
                </button>
                <div className="request-header-container">
                    <div className="request-item">
                        <span className="request-label">Request Id:</span>
                        <span className="request-value">{record.requestID}</span>
                    </div>
                    <div className="request-item">
                        <span className="request-label">Agency:</span>
                        <span className="request-value">
                            {record.agencyID && record.agencyName
                                ? `${record.agencyID} - ${record.agencyName}`
                                : "NA"}
                        </span>
                    </div>
                    <div className="request-item">
                        <span className="request-label">Files & Cases:</span>
                        <span className="request-value">
                            {/* {record.filesCount ?? "0"}/{record.casesCount ?? "0"} */}
                            {
                                record.filesCount === 0
                                    ? 'No Files'
                                    : (record.casesCount || 0) === 0
                                        ? `${record.filesCount} ${record.filesCount === 1 ? 'File' : 'Files'} & Cases Yet to Start`
                                        : `${record.filesCount} ${record.filesCount === 1 ? 'File' : 'Files'} with ${record.casesCount} ${record.casesCount === 1 ? 'Case' : 'Cases'}`
                            }
                        </span>
                    </div>
                    <div className="request-item">
                        <span className="request-label">Status:</span>
                        <span className="request-value">
                            {record.outgoingRequest_Status || "Sent"}
                        </span>
                    </div>
                    <div className="request-item">
                        <span className="request-label">Req PDF:</span>
                        <span
                            className="request-value link"
                            onClick={() => handleViewPDF(record.pdfForm?.s3Key)}
                        >
                            View PDF
                        </span>
                    </div>
                </div>
            </div>

            <div className="custom-bg-white main-content-2_RD mt-4 p-3">
                <div className="inner-content_RD">

                    {/* ── Section 1: Events ── */}
                    <div className="accordion-item1_RD">
                        <div className="accordion-header_RD" onClick={() => toggleSection("events")}>
                            <div className="header-left_RD">
                                <span>Events</span>
                            </div>
                            <div className="header-right_RD">
                                {openSection.includes("events") && (
                                    <span className="add-note-link_RD" onClick={(e) => { e.stopPropagation(); setEventData({ startDateTime: "", endDateTime: "", message: "" }); setShowEventModal(true); setEventErrors({}); }}>
                                        + Add Event
                                    </span>
                                )}
                                <span>{openSection.includes("events") ? <IoIosArrowUp /> : <IoIosArrowDown />}</span>
                            </div>
                        </div>
                        {openSection.includes("events") && (
                            <div className="accordion-content_RD">
                                {(record.events || []).length === 0 ? (
                                    <div className="empty-text_RD">No events found.</div>
                                ) : (
                                    <div className="table-content-files">
                                        <table className="files-table">
                                            <thead>
                                                <tr>
                                                    <th>S.No</th>
                                                    <th>Start Date Time</th>
                                                    <th>End Date Time</th>
                                                    <th>Message</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {(record.events || []).map((ev, i) => (
                                                    <tr key={i}>
                                                        <td>{i + 1}</td>
                                                        <td>{ev.startDateTime ? formatToLocalDateTime(ev.startDateTime) : "NA"}</td>
                                                        <td>{ev.endDateTime ? formatToLocalDateTime(ev.endDateTime) : "NA"}</td>
                                                        <td>{ev.message || "NA"}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>

                    {/* ── Section 2: Cheques ── */}
                    <div className="accordion-item1_RD">

                        <div
                            className="accordion-header_RD"
                            onClick={() => toggleSection("cheque")}
                        >
                            <div className="header-left_RD">
                                <span>Cheque</span>
                            </div>

                            <div className="header-right_RD">

                                {openSection.includes("cheque") && (
                                    <span
                                        className="add-note-link_RD"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleOpenChequeModal();
                                        }}
                                    >
                                        + Add Cheque
                                    </span>
                                )}

                                <span>
                                    {openSection.includes("cheque")
                                        ? <IoIosArrowUp />
                                        : <IoIosArrowDown />}
                                </span>
                            </div>
                        </div>

                        {openSection.includes("cheque") && (

                            <div className="accordion-content_RD_cheques">

                                {(!record.cheques || record.cheques.length === 0) ? (

                                    <div className="py-3 empty-text_RD">
                                        No cheque added.
                                    </div>

                                ) : (

                                    <div className="table-content-files">

                                        <table className="files-event-table">

                                            <thead>
                                                <tr>
                                                    <th>S.No</th>
                                                    <th>Payable To</th>
                                                    <th>Amount</th>
                                                    <th>Memo</th>
                                                    <th>Generated By</th>
                                                    <th>Generated On</th>
                                                    <th>View</th>
                                                </tr>
                                            </thead>

                                            <tbody>

                                                {/* {(record.cheque || []).map((cheque, index) => ( */}

                                                {(
                                                    Array.isArray(record.cheques)
                                                        ? record.cheques
                                                        : typeof record.cheques === "string"
                                                            ? JSON.parse(record.cheques)
                                                            : [record.cheques]
                                                ).map((cheque, index) => (

                                                    <tr key={index}>

                                                        <td>
                                                            {index + 1}
                                                        </td>

                                                        <td>
                                                            {cheque.payableTo || "NA"}
                                                        </td>

                                                        <td>
                                                            {cheque.amount || "NA"}
                                                        </td>

                                                        <td>
                                                            {cheque.memo || "NA"}
                                                        </td>

                                                        <td>
                                                            {cheque.created_by_email_id || "NA"}
                                                        </td>

                                                        <td>
                                                            {
                                                                formatToLocalDateTime(
                                                                    cheque.generatedOn?.$date ||
                                                                    cheque.generatedOn
                                                                ) || "NA"
                                                            }
                                                        </td>

                                                        <td>
                                                            {cheque?.s3Key ? (
                                                                <FaEye
                                                                    size={16}
                                                                    className="adp-cheque-view-btn"
                                                                    title="View Cheque"
                                                                    onClick={() => handleViewCheque(cheque)}
                                                                />
                                                            ) : (
                                                                "-"
                                                            )}
                                                        </td>

                                                    </tr>

                                                ))}

                                            </tbody>

                                        </table>

                                    </div>

                                )}

                            </div>

                        )}

                    </div>

                    {/* ── Section 3: Notes ── */}
                    <div className="accordion-item1_RD">
                        <div className="accordion-header_RD" onClick={() => toggleSection("notes")}>
                            <div className="header-left_RD">
                                <span>Notes</span>
                            </div>
                            <div className="header-right_RD">
                                {openSection.includes("notes") && (
                                    <span className="add-note-link_RD" onClick={(e) => { e.stopPropagation(); setTextArea(""); setShowAddModal(true); }}>
                                        + Add Note
                                    </span>
                                )}
                                <span>{openSection.includes("notes") ? <IoIosArrowUp /> : <IoIosArrowDown />}</span>
                            </div>
                        </div>
                        {openSection.includes("notes") && (
                            <div className="accordion-content_RD">
                                {notes.length === 0 ? (
                                    <p style={{ color: "#888", fontSize: 13 }}>No notes yet.</p>
                                ) : (
                                    <div className="notes-view-body_RD">
                                        {[...notes]
                                            .filter(note => note.text?.trim())
                                            .sort((a, b) => {
                                                const aPinned = a.isPinned === true;
                                                const bPinned = b.isPinned === true;
                                                if (bPinned !== aPinned) return (bPinned ? 1 : 0) - (aPinned ? 1 : 0);
                                                const dateA = new Date(a.addedTimestamp?.$date || a.addedTimestamp || a.createdAt || a.time || 0);
                                                const dateB = new Date(b.addedTimestamp?.$date || b.addedTimestamp || b.createdAt || b.time || 0);
                                                return dateB - dateA;
                                            })
                                            .map((note, idx) => {
                                                const rawText = note.text || "";
                                                const first50 = rawText.substring(0, 50);
                                                const matchedStatus = viewHighlightFileds.find(s => first50.startsWith(s));
                                                return (
                                                    <div key={idx} className="note-item_RD">
                                                        <p className="note-text_RD">
                                                            {note.isPinned && (
                                                                <span style={{
                                                                    display: "inline-flex",
                                                                    alignItems: "center",
                                                                    gap: 3,
                                                                    background: "#fff3cd",
                                                                    color: "#b45309",
                                                                    fontSize: 10,
                                                                    fontWeight: 600,
                                                                    borderRadius: 4,
                                                                    padding: "1px 6px",
                                                                    marginRight: 5,
                                                                    border: "1px solid #fcd34d"
                                                                }}>
                                                                    <BsPinAngleFill size={10} /> Pinned
                                                                </span>
                                                            )}
                                                            <GoDotFill size={12} />{" "}

                                                            {matchedStatus ? (
                                                                <><span className="status-highlight_RD">{matchedStatus}</span>{" "}{rawText.substring(matchedStatus.length).trim()}</>
                                                            ) : rawText}
                                                        </p>
                                                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                                            <p className="note-meta_RD" style={{ margin: 0 }}>
                                                                {note.updated_by_email_id || note.addedBy} at {formatToLocalDateTime(note.addedTimestamp || note.addedTimestamp?.$date)}
                                                            </p>
                                                            <button
                                                                title={note.isPinned ? "Unpin note" : "Pin note"}
                                                                onClick={() => {
                                                                    const originalIndex = record.notes.findIndex(n => n === note);
                                                                    handlePinNote(originalIndex, note.isPinned);
                                                                }}
                                                                className={`pin-btn_RD ${note.isPinned ? "pinned" : ""}`}
                                                            >
                                                                {note.isPinned
                                                                    ? <BsPinAngleFill size={16} />
                                                                    : <BsPinAngle size={16} />
                                                                }
                                                            </button>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                    </div>
                                )}
                            </div>
                        )}
                    </div>

                    {/* ── Section 4: Request Details ── */}
                    <div className="accordion-item1_RD">
                        <div
                            className="accordion-header_RD"
                            onClick={() => toggleSection("requestResponse")}
                        >
                            <span>Request Details</span>
                            <span>
                                {openSection.includes("requestResponse")
                                    ? <IoIosArrowUp />
                                    : <IoIosArrowDown />}
                            </span>
                        </div>

                        {openSection.includes("requestResponse") && (
                            <div className="accordion-content_RD">

                                <table className="request-details-table_RD">
                                    <thead>
                                        <tr>
                                            <th>Request Type</th>
                                            <th>Request Email Address</th>
                                            <th>Response Type</th>
                                            <th>Offset Begins</th>
                                            <th>Offset Ends</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr>
                                            <td>{record.requestMethod?.requestType || "-"}</td>

                                            <td>{getRequestEmailAddress() || "-"}</td>

                                            <td>{record.responseMethod?.responseType || "-"}</td>

                                            <td>{record.reqRange?.offsetBegins ?? "-"}</td>

                                            <td>{record.reqRange?.offsetEnds ?? "-"}</td>

                                            <td>{record.outgoingRequest_Status || "-"}</td>
                                        </tr>
                                    </tbody>
                                </table>

                            </div>
                        )}
                    </div>

                    {/* ── Section 5: Email Links ── */}
                    <div className="accordion-item1_RD">
                        <div className="accordion-header_RD" onClick={() => toggleSection("emailLinks")}>
                            <span>Email Links</span>
                            <span>{openSection.includes("emailLinks") ? <IoIosArrowUp /> : <IoIosArrowDown />}</span>
                        </div>
                        {openSection.includes("emailLinks") && (
                            <div className="accordion-content_RD">
                                {(() => {
                                    const reqEmails = Array.isArray(record.requestMethod?.emailSettings)
                                        ? record.requestMethod.emailSettings
                                        : [];

                                    const resEmails = Array.isArray(record.responseMethod?.emailSettings)
                                        ? record.responseMethod.emailSettings
                                        : [];
                                    const allEmails = [...reqEmails, ...resEmails];
                                    return allEmails.length === 0 ? (
                                        <div className="empty-text_RD">No email links available.</div>
                                    ) : (
                                        <div className="section-card_RD">
                                            <label>Email Links</label>
                                            {allEmails.map((email, i) => (
                                                <div key={i} className="input-section_RD full-width_RD">
                                                    <input readOnly value={email} />
                                                </div>
                                            ))}
                                        </div>
                                    );
                                })()}
                            </div>
                        )}
                    </div>

                    {/* ── Section 6: Files ── */}
                    <div className="accordion-item1_RD">
                        <div
                            className="accordion-header_RD"
                            onClick={() => toggleSection("files")}
                        >
                            <span>Files</span>
                            <span>
                                {openSection.includes("files") ? <IoIosArrowUp /> : <IoIosArrowDown />}
                            </span>
                        </div>
                        {openSection.includes("files") && (
                            <div className="accordion-content_RD">
                                {!record.filesData || record.filesData.length === 0 ? (
                                    <div className="empty-text_RD">No file data available.</div>
                                ) : (
                                    <div className="table-content-files">
                                        <table className="files-table">
                                            <thead>
                                                <tr>
                                                    <th>File Name</th>
                                                    <th>Pages</th>
                                                    <th>Cases Count</th>
                                                    <th>Entry Status</th>
                                                    <th>Entry By</th>
                                                    <th>Uploaded Time</th>
                                                    <th>Entry Started</th>
                                                    <th>Entry Completed</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {(Array.isArray(record.filesData)
                                                    ? record.filesData
                                                    : [record.filesData]
                                                ).map((file, index) => (
                                                    <tr key={index}>
                                                        <td>
                                                            {file.s3_url ? (
                                                                <a
                                                                    href={file.s3_url}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    style={{
                                                                        color: "#006d99",
                                                                        textDecoration: "underline",
                                                                        cursor: "pointer",
                                                                        fontWeight: 400
                                                                    }}
                                                                >
                                                                    {file.file_name || "View File"}
                                                                </a>
                                                            ) : (
                                                                file.file_name || "NA"
                                                            )}
                                                        </td>
                                                        <td>{file.pages ?? "NA"}</td>
                                                        <td>{file.casesCount ?? "0"}</td>
                                                        <td>{file.entry_status || "NA"}</td>
                                                        <td>{file.entry_by_email_id || "NA"}</td>
                                                        <td>{formatToLocalDateTime(file.uploaded_time) || "NA"}</td>
                                                        <td>{formatToLocalDateTime(file.entry_started_time) || "NA"}</td>
                                                        <td>{formatToLocalDateTime(file.entry_completed_time) || "NA"}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>

                    {/* ── Section 7: HISTORY ── */}
                    <div className="accordion-item1_RD">
                        <div
                            className="accordion-header_RD"
                            onClick={handleHistoryToggle}
                        >
                            <span>Call History</span>
                            <span>
                                {openSection.includes("history") ? <IoIosArrowUp /> : <IoIosArrowDown />}
                            </span>
                        </div>

                        {openSection.includes("history") && (
                            <div className="call-history-body-sent">
                                {record && shouldShowCallAction(record) && (
                                    <div className="call-action-container">
                                        <button className="call-action-btn"
                                            onClick={handleOpenCallforAction}>
                                            <BiSolidPhoneCall className="call-btn-icon" />
                                            Call for Action
                                        </button>
                                    </div>
                                )}

                                {(!callHistory || callHistory.length === 0) ? (
                                    <div className="empty-text_RD">
                                        <p>No call history found.</p>
                                    </div>
                                ) : (
                                    <div className="call-history-cards">
                                        {callHistory.map((item, index) => {
                                            const total = Math.floor(item.call_duration || 0);
                                            const mins = String(Math.floor(total / 60)).padStart(2, "0");
                                            const secs = String(total % 60).padStart(2, "0");

                                            const duration = `${mins}:${secs}`;
                                            const date = item.updated_at
                                                ? new Date(item.updated_at).toLocaleString()
                                                : "—";
                                            const avatarLetter = (item.agent_email || "?")[0].toUpperCase();


                                            return (
                                                <div className="call-history-card" key={item._id || index}>

                                                    <audio
                                                        ref={audioRef}
                                                        onEnded={() => {
                                                            setIsPlaying(false);
                                                            setPlayingId(null);
                                                        }}
                                                    />

                                                    {/* ── Top color strip ── */}
                                                    <div className="call-history-card-strip" />

                                                    {/* ── Card Header ── */}
                                                    <div className="call-history-card-header">
                                                        <div className="call-history-agent">


                                                            {item.call_s3_key && item.call_analysis_data && (
                                                                <div className="call-history-recording-row">
                                                                    <button
                                                                        className="call-history-play-btn"
                                                                        onClick={() => {
                                                                            handlePlay(item.call_s3_key, item._id); // ← your existing logic, untouched
                                                                            setModalItem(item);                      // ← track which item
                                                                            setModalOpen(true);                      // ← open modal
                                                                        }}
                                                                    >
                                                                        {playingId === item._id && isPlaying ? "⏸" : "▶"}
                                                                    </button>

                                                                </div>
                                                            )}
                                                            <div>
                                                                <div className="call-history-agent-email">
                                                                    {item.agent_email || "-"}
                                                                </div>
                                                                <div className="call-history-date">🕐 {date}</div>
                                                            </div>
                                                        </div>
                                                        {
                                                            !item.call_analysis_data && (
                                                                <div className="call-history-recording-row">
                                                                    <span style={{ fontSize: "12px" }}>No Recording</span>
                                                                </div>
                                                            )
                                                        }
                                                        {item.call_analysis_data && (
                                                            <div className="call-history-duration-badge">
                                                                ⏱ {duration}
                                                            </div>
                                                        )}
                                                    </div>

                                                    {/* ── Card Body ── */}
                                                    <div className="call-history-card-body">

                                                        {/* From / To row */}
                                                        <div className="call-history-info-row">
                                                            <div className="call-history-info-box">
                                                                <span className="call-history-info-icon">
                                                                    <FiPhoneOutgoing style={{ color: "#1976d2" }} />
                                                                </span>
                                                                <div>
                                                                    <span className="call-history-label">From</span>
                                                                    <span className="call-history-value">{item.called_from || "—"}</span>
                                                                </div>
                                                            </div>
                                                            <div className="call-history-info-divider" />
                                                            <div className="call-history-info-box">
                                                                <span className="call-history-info-icon">
                                                                    <FiPhone style={{ color: "#2e7d32" }} />
                                                                </span>
                                                                <div>
                                                                    <span className="call-history-label">To</span>
                                                                    <span className="call-history-value">{item.called_to || "—"}</span>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Notes */}
                                                        <div className="call-history-notes-box">
                                                            <span className="call-history-label">📝 Notes</span>
                                                            <p className="call-history-notes-text">
                                                                {item.notes || "No notes added."}
                                                            </p>
                                                        </div>


                                                        <div
                                                            className="ca-trigger-row"
                                                            style={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "space-between",
                                                                gap: 8,
                                                                width: "100%"
                                                            }}
                                                        >
                                                            {/* Call Status should show for ALL cards */}
                                                            {item.call_status && (
                                                                <span
                                                                    style={{
                                                                        fontSize: 11,
                                                                        fontWeight: 500,

                                                                        color:
                                                                            item.call_status === "Unable to contact"
                                                                                ? "#d32f2f"
                                                                                : item.call_status === "Left voice message"
                                                                                    ? "#1976d2"
                                                                                    : item.call_status === "Spoke to person"
                                                                                        ? "#2e7d32"
                                                                                        : "#555",

                                                                        background:
                                                                            item.call_status === "Unable to contact"
                                                                                ? "#fdecea"
                                                                                : item.call_status === "Left voice message"
                                                                                    ? "#e3f2fd"
                                                                                    : item.call_status === "Spoke to person"
                                                                                        ? "#e8f5e9"
                                                                                        : "#f5f5f5",

                                                                        border:
                                                                            item.call_status === "Unable to contact"
                                                                                ? "1px solid #ef9a9a"
                                                                                : item.call_status === "Left voice message"
                                                                                    ? "1px solid #90caf9"
                                                                                    : item.call_status === "Spoke to person"
                                                                                        ? "1px solid #81c784"
                                                                                        : "1px solid #d1d5db",

                                                                        borderRadius: 6,
                                                                        padding: "3px 10px",
                                                                        whiteSpace: "nowrap"
                                                                    }}
                                                                >
                                                                    {item.call_status}
                                                                </span>
                                                            )}

                                                            {/* Analysis button only when analysis exists */}
                                                            {item.call_analysis_data && (
                                                                <button
                                                                    className="ca-trigger-btn"
                                                                    onClick={() =>
                                                                        setExpandedAnalysis(prev =>
                                                                            prev === item._id ? null : item._id
                                                                        )
                                                                    }
                                                                >
                                                                    <MdOutlineAnalytics size={11} />
                                                                    <span>Analysis</span>

                                                                    <FiChevronDown
                                                                        size={10}
                                                                        style={{
                                                                            transition: "transform 0.2s",
                                                                            transform:
                                                                                expandedAnalysis === item._id
                                                                                    ? "rotate(180deg)"
                                                                                    : "rotate(0deg)"
                                                                        }}
                                                                    />
                                                                </button>
                                                            )}
                                                        </div>

                                                        {item.call_analysis_data && expandedAnalysis === item._id &&
                                                            ReactDOM.createPortal(
                                                                <>
                                                                    <div className="ca-backdrop" />
                                                                    <div className="ca-modal">

                                                                        {/* ── Modal Header ── */}
                                                                        <div className="ca-modal-header">
                                                                            <div className="ca-modal-title">
                                                                                <MdOutlineAnalytics size={15} />
                                                                                <span>Call Details</span>
                                                                            </div>
                                                                            <button className="ca-modal-close" onClick={closeAnalysisModal}>
                                                                                <MdCancel size={13} />
                                                                            </button>
                                                                        </div>

                                                                        {/* ── Two column layout ── */}
                                                                        <div className="ca-modal-body">

                                                                            {/* ══ LEFT COLUMN: Card Info ══ */}
                                                                            <div className="ca-col ca-col-left">

                                                                                {/* Agent + Duration */}
                                                                                <div className="ca-section-label">
                                                                                    <FiVolume2 size={10} /> Audio Recording
                                                                                </div>
                                                                                <div className="ca-info-header">
                                                                                    {item.call_s3_key ? (
                                                                                        <button
                                                                                            className="ca-play-btn"
                                                                                            onClick={() => {
                                                                                                handlePlay(item.call_s3_key, item._id);
                                                                                                setModalItem(item);
                                                                                                setModalOpen(true);
                                                                                            }

                                                                                            }
                                                                                        >
                                                                                            {playingId === item._id && isPlaying
                                                                                                ? <FiPause size={15} />
                                                                                                : <FiPlay size={15} />
                                                                                            }

                                                                                        </button>
                                                                                    ) : (
                                                                                        <div className="ca-no-avatar">
                                                                                            <FiMicOff size={15} />No recording available
                                                                                        </div>
                                                                                    )}
                                                                                    <div className="ca-agent-info">
                                                                                        <span className="ca-agent-name">{item.agent_email || "—"}</span>
                                                                                        <span className="ca-agent-date">
                                                                                            <FiClock size={10} />
                                                                                            {item.updated_at ? new Date(item.updated_at).toLocaleString() : "—"}
                                                                                        </span>
                                                                                    </div>

                                                                                    {item.call_s3_key && (
                                                                                        <div className="ca-duration-pill">
                                                                                            <FiClock size={10} />
                                                                                            <span>{duration}</span>
                                                                                        </div>
                                                                                    )}
                                                                                </div>


                                                                                {/* From / To */}
                                                                                <div className="ca-section-label">
                                                                                    <FiPhone size={10} /> Call Route
                                                                                </div>
                                                                                <div className="ca-from-to">
                                                                                    <div className="ca-route-box from">
                                                                                        <span className="ca-route-label">
                                                                                            <FiPhoneOutgoing size={10} /> From
                                                                                        </span>
                                                                                        <span className="ca-route-value">{item.called_from || "—"}</span>
                                                                                    </div>
                                                                                    <div className="ca-route-arrow">
                                                                                        <FiArrowRight size={14} />
                                                                                    </div>
                                                                                    <div className="ca-route-box to">
                                                                                        <span className="ca-route-label">
                                                                                            <FiPhoneIncoming size={10} /> To
                                                                                        </span>
                                                                                        <span className="ca-route-value">{item.called_to || "—"}</span>
                                                                                    </div>
                                                                                </div>

                                                                                {/* Notes */}
                                                                                <div className="ca-section-label">
                                                                                    <FiFileText size={10} /> Notes
                                                                                </div>
                                                                                <p className="ca-notes-text">{item.notes || "No notes added."}</p>

                                                                                {/* Issues */}
                                                                                {item.call_analysis_data.call_issues && (
                                                                                    <>
                                                                                        <div className="ca-section-label issues-label">
                                                                                            <FiAlertCircle size={10} /> Issues
                                                                                        </div>
                                                                                        <p className="ca-block-text issues">{item.call_analysis_data.call_issues}</p>
                                                                                    </>
                                                                                )}
                                                                            </div>

                                                                            {/* ══ RIGHT COLUMN: Analysis ══ */}
                                                                            <div className="ca-col ca-col-right">

                                                                                {/* Sentiments */}
                                                                                <div className="ca-section-label">
                                                                                    <BsRobot size={10} /> Call Analysis
                                                                                </div>
                                                                                <div className="ca-sentiment-row">
                                                                                    <div className="ca-sentiment agent">
                                                                                        <RiCustomerService2Fill size={15} />
                                                                                        <div>
                                                                                            <span className="ca-sent-label">Agent</span>
                                                                                            <span className="ca-sent-value">{item.call_analysis_data.agent_sentiment || "—"}</span>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="ca-sentiment customer">
                                                                                        <BsPerson size={15} />
                                                                                        <div>
                                                                                            <span className="ca-sent-label">Customer</span>
                                                                                            <span className="ca-sent-value">{item.call_analysis_data.customer_sentiment || "—"}</span>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>

                                                                                {/* Summary */}
                                                                                {item.call_analysis_data.call_summary && (
                                                                                    <>
                                                                                        <div className="ca-section-label">
                                                                                            <FiFileText size={10} /> Summary
                                                                                        </div>
                                                                                        <p className="ca-block-text">{item.call_analysis_data.call_summary}</p>
                                                                                    </>
                                                                                )}



                                                                                {/* Transcript */}
                                                                                {item.call_analysis_data.call_transcript?.length > 0 && (
                                                                                    <>
                                                                                        <div className="ca-section-label">
                                                                                            <FiMessageSquare size={10} /> Transcript
                                                                                        </div>
                                                                                        <div className="ca-transcript-list">
                                                                                            {item.call_analysis_data.call_transcript.map((line, i) => {
                                                                                                const isCustomer = line.startsWith("Customer:");
                                                                                                const text = line.replace(/^(Customer|Agent):\s*/, "");
                                                                                                return (
                                                                                                    <div key={i} className={`ca-bubble-row ${isCustomer ? "agent" : "customer"}`}>
                                                                                                        <div className="ca-bubble">
                                                                                                            <span className="ca-speaker">
                                                                                                                {isCustomer ? <><BsPerson size={9} /> Customer</> : <><RiCustomerService2Fill size={9} /> Agent</>}
                                                                                                            </span>
                                                                                                            <p className="ca-bubble-text">{text}</p>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                );
                                                                                            })}
                                                                                        </div>
                                                                                    </>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </>,
                                                                document.body
                                                            )
                                                        }

                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* ── Add Note Modal ── */}
            {showAddModal && (
                <div className="add-text-req_RD">
                    <div className="add-text-req-body_RD">
                        <div className="add-text-reqheader_RD">
                            <span>Add Note</span>
                            <MdCancel size={24} className="closeAddForm_RD" onClick={() => { setShowAddModal(false); setNoteError(""); }} />
                        </div>
                        <form onSubmit={handleTextSubmit}>
                            <div className="req-text-field_RD">
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 4 }}>
                                    <label className="form-label" style={{ margin: 0 }}>
                                        Note <span style={{ color: "#dc2626" }}>*</span>
                                    </label>
                                    <button
                                        type="button"
                                        title={isPinned ? "Unpin this note" : "Pin this note to top"}
                                        onClick={() => setIsPinned(p => !p)}
                                        style={{
                                            background: isPinned ? "#fff3cd" : "#f5f5f5",
                                            border: isPinned ? "1px solid #f59e0b" : "1px solid #cbd5e1",
                                            borderRadius: 6,
                                            cursor: "pointer",
                                            fontSize: 12,
                                            fontWeight: 600,
                                            color: isPinned ? "#b45309" : "#374151",
                                            padding: "3px 10px",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 6,
                                            transition: "all 0.2s"
                                        }}
                                    >
                                        {isPinned ? <BsPinAngleFill size={14} /> : <BsPinAngle size={14} />}
                                        {isPinned ? "Pinned" : "Pin"}
                                    </button>
                                </div>
                                <textarea className={`form-control ${noteError ? "is-invalid" : ""}`}
                                    rows={3}
                                    value={textArea}
                                    onChange={(e) => {
                                        const value = e.target.value.replace(/^\s+/, "");
                                        setTextArea(value);
                                        if (noteError) setNoteError("");
                                    }}
                                    placeholder="Enter notes"
                                />
                                {noteError && <div className="error-text-Note">{noteError}</div>}
                                <button type="submit" className="req-text-field-btn_RD mt-3">Submit</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* ── Add Event Modal ── */}
            {showEventModal && (
                <div className="add-text-req_RD">
                    <div className="add-text-req-body_RD">
                        <div className="add-text-reqheader_RD">
                            <span>Add Event</span>
                            <MdCancel size={24} className="closeAddForm_RD" onClick={() => setShowEventModal(false)} />
                        </div>
                        <form onSubmit={handleEventSubmit}>
                            <div className="req-text-field_RD">
                                <label className="form-label">Start Date Time <span style={{ color: "#dc2626" }}>*</span></label>
                                <input type="datetime-local"
                                    className={`form-control ${eventErrors.startDateTime ? "is-invalid" : ""}`}
                                    value={eventData.startDateTime}
                                    min={getNowDateTimeLocal()}
                                    onChange={(e) => {
                                        setEventData({ ...eventData, startDateTime: e.target.value });
                                        if (eventErrors.startDateTime) setEventErrors(p => ({ ...p, startDateTime: "" }));
                                    }} />
                                {eventErrors.startDateTime && <div className="error-text-Note">{eventErrors.startDateTime}</div>}
                                <label className="form-label mt-3">End Date Time <span style={{ color: "#dc2626" }}>*</span></label>
                                <input type="datetime-local"
                                    className={`form-control ${eventErrors.endDateTime ? "is-invalid" : ""}`}
                                    value={eventData.endDateTime}
                                    min={eventData.startDateTime || getNowDateTimeLocal()}
                                    onChange={(e) => {
                                        setEventData({ ...eventData, endDateTime: e.target.value });
                                        if (eventErrors.endDateTime) setEventErrors(p => ({ ...p, endDateTime: "" }));
                                    }} />
                                {eventErrors.endDateTime && <div className="error-text-Note">{eventErrors.endDateTime}</div>}

                                <label className="form-label mt-3">Message</label>
                                <input type="text" className="form-control" placeholder="Enter message" value={eventData.message}
                                    onChange={(e) => setEventData({ ...eventData, message: e.target.value.replace(/^\s+/, "") })} />
                                <button type="submit" className="req-text-field-btn_RD mt-3">Submit</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
            {/* ── Add Cheque Modal ── */}
            {showChequeModal && (
                <div className="notes-status-overlay_RD">
                    <div className="notes-status_RD">
                        <div className="notes-status-header_RD">
                            <span>{chequeData?.s3Key ? "View Cheque" : "Add Cheque"}</span>
                            <MdCancel size={24} className="closeAddForm_RD" onClick={() => { setShowChequeModal(false); setChequeErrors({}); }} />
                        </div>
                        <div className="notes-status-body_RD">
                            {chequeData?.s3Key ? (
                                <div className="submit-btn-container_RD">
                                    <button type="button" className="req-status-field-btn_RD" onClick={() => handleViewCheque(chequeData)}>
                                        View Cheque
                                    </button>
                                </div>
                            ) : (
                                <form onSubmit={handleGenerateCheque}>
                                    <div className="req-add-fieldcheque_RD">
                                        <div className="req-form-row_RD">
                                            <div className="req-status-field_RD">
                                                <label>Payable To <span style={{ color: "#dc2626" }}>*</span></label>
                                                <input type="text" className={`form-control ${chequeErrors.payableTo ? "is-invalid" : ""}`}
                                                    placeholder="Enter payable to"
                                                    value={chequePaymentTo}
                                                    onChange={handlePayableToChange}
                                                />
                                                {chequeErrors.payableTo && <div className="error-text-Note">{chequeErrors.payableTo}</div>}
                                            </div>
                                            <div className="req-status-field_RD">
                                                <label>Amount <span style={{ color: "#dc2626" }}>*</span></label>
                                                <input
                                                    type="text"
                                                    className={`form-control ${chequeErrors.amount ? "is-invalid" : ""}`}
                                                    placeholder="Enter amount"
                                                    value={chequeAmount}
                                                    onChange={handleAmountChange}
                                                />
                                                {chequeErrors.amount && <div className="error-text-Note">{chequeErrors.amount}</div>}
                                            </div>
                                        </div>
                                        <div className="req-form-row_RD">
                                            <div className="req-left-column_RD">
                                                <div className="req-status-field_RD address-field_RD">
                                                    <label>Address <span style={{ color: "#dc2626" }}>*</span></label>
                                                    <textarea
                                                        className={`form-control ${chequeErrors.address ? "is-invalid" : ""}`}
                                                        rows={2}
                                                        placeholder="Enter address"
                                                        value={chequeAddress.address}
                                                        onChange={(e) => {
                                                            const value = e.target.value.replace(/^\s+/, "");
                                                            setChequeAddress({ ...chequeAddress, address: value });
                                                            if (chequeErrors.address) setChequeErrors(p => ({ ...p, address: "" }));
                                                        }}
                                                    />
                                                    {chequeErrors.address && <div className="error-text-Note">{chequeErrors.address}</div>}
                                                </div>
                                                <div className="req-status-field_RD">
                                                    <label>Memo</label>
                                                    <textarea
                                                        className="form-control"
                                                        rows={3}
                                                        placeholder="Enter memo"
                                                        value={chequeMemo}
                                                        onChange={(e) => setChequeMemo(e.target.value.replace(/^\s+/, ""))}
                                                    />
                                                </div>
                                            </div>
                                            <div className="req-right-column_RD">
                                                <div className="req-status-field_RD">
                                                    <label>City <span style={{ color: "#dc2626" }}>*</span></label>
                                                    <input
                                                        className={`form-control ${chequeErrors.city ? "is-invalid" : ""}`}
                                                        placeholder="Enter city"
                                                        value={chequeAddress.city}
                                                        onChange={(e) => {
                                                            const value = e.target.value.replace(/^\s+/, "");
                                                            setChequeAddress({ ...chequeAddress, city: value });
                                                            if (chequeErrors.city) setChequeErrors(p => ({ ...p, city: "" }));
                                                        }}
                                                    />
                                                    {chequeErrors.city && <div className="error-text-Note">{chequeErrors.city}</div>}
                                                </div>
                                                <div className="req-status-field_RD">
                                                    <label>State <span style={{ color: "#dc2626" }}>*</span></label>
                                                    <input
                                                        className={`form-control ${chequeErrors.state ? "is-invalid" : ""}`}
                                                        placeholder="Enter state"
                                                        value={chequeAddress.state}
                                                        onChange={(e) => {
                                                            const value = e.target.value.replace(/^\s+/, "");
                                                            setChequeAddress({ ...chequeAddress, state: value });
                                                            if (chequeErrors.state) setChequeErrors(p => ({ ...p, state: "" }));
                                                        }}
                                                    />
                                                    {chequeErrors.state && <div className="error-text-Note">{chequeErrors.state}</div>}
                                                </div>
                                                <div className="req-status-field_RD">
                                                    <label>Zip <span style={{ color: "#dc2626" }}>*</span></label>
                                                    <input
                                                        className={`form-control ${chequeErrors.zip ? "is-invalid" : ""}`}
                                                        placeholder="Enter zip"
                                                        value={chequeAddress.zip}
                                                        onChange={(e) => {
                                                            const value = e.target.value.replace(/^\s+/, "");
                                                            setChequeAddress({ ...chequeAddress, zip: value });
                                                            if (chequeErrors.zip) setChequeErrors(p => ({ ...p, zip: "" }));
                                                        }}
                                                    />
                                                    {chequeErrors.zip && <div className="error-text-Note">{chequeErrors.zip}</div>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="submit-btn-container_RD">
                                            <button type="submit" className="req-status-field-btn_RD">Generate Cheque</button>
                                        </div>
                                    </div>
                                </form>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {/* ── View Cheque Modal ── */}
            {showViewChequeModal && (
                <div className="notes-status-overlay_RD">
                    <div className="view-cheque-modal_RD">
                        <div className="notes-status-header_RD">
                            <span className="view-cheque-header_RD">Cheque : ({viewChequeRequestId})</span>
                            <MdCancel size={24} className="closeAddForm_RD"
                                onClick={() => { setShowViewChequeModal(false); setChequePdfUrl(""); }} />
                        </div>
                        <div className="view-cheque-body_RD">
                            <iframe src={chequePdfUrl} title="Cheque PDF" className="cheque-pdf-viewer_RD" />
                        </div>
                    </div>
                </div>
            )}
            <CallRecordingPlayerModal
                isOpen={modalOpen}
                onClose={() => {

                    // stop audio
                    if (audioRef.current) {
                        audioRef.current.pause();
                        audioRef.current.currentTime = 0;
                        audioRef.current.src = "";
                    }

                    // reset states
                    setIsPlaying(false);
                    setPlayingId(null);
                    setAudioUrl(null);

                    // close modal
                    setModalOpen(false);
                }}
                audioRef={audioRef}
                audioUrl={audioUrl}
                callItem={modalItem}
            />

            <DialModal
                isOpen={dialOpen}
                onClose={() => setDialOpen(false)}
                requestID={dialRequestId}
                agencyPhoneNumber={record?.agencyPhoneNumber}
                fetchHistory={fetchCallHistory}
                refresh={refreshPage}
            />

        </div>
    );
};

export default RequestDetail;